import * as React from "react";
const IconTimer = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M34.3 12V6.3h5.4c1.2 0 2.3-1 2.3-2.3s-1-2.3-2.3-2.3H24.4c-1.2 0-2.3 1-2.3 2.3s1 2.3 2.3 2.3h5.4V12c-12.9 1.2-23 12-23 25.1C6.8 51 18.1 62.3 32 62.3S57.2 51 57.2 37.1C57.2 24 47.1 13.2 34.3 12M32 57.8c-11.4 0-20.7-9.3-20.7-20.7S20.6 16.4 32 16.4s20.7 9.3 20.7 20.7S43.4 57.8 32 57.8" />
    <path d="M44.7 34.8H34.3V24.4c0-1.2-1-2.3-2.3-2.3-1.2 0-2.3 1-2.3 2.3v10.5h-2.8c-1.2 0-2.3 1-2.3 2.3s1 2.3 2.3 2.3h2.8v2.8c0 1.2 1 2.3 2.3 2.3 1.2 0 2.3-1 2.3-2.3v-2.8h10.5c1.2 0 2.3-1 2.3-2.3s-1.1-2.4-2.4-2.4" />
  </svg>
);
export default IconTimer;
